<template>
    <div>
        <b-modal
            :visible="value"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                 Upload Blueprint
            </template>

            <div>
                <div class="col-lg-12 order-lg-1 order-2">
                    <div class="mb-3">
                        New Media
                        <b-form-file
                        v-model="submit_data.file"
                        :state="Boolean(submit_data.file)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        ></b-form-file>
                        <b-form-invalid-feedback :state="!submit_data.file ? false : null">
                            Media is required
                        </b-form-invalid-feedback>
                    </div>
                </div>
            </div>
            <div v-if="returned_data">
                    <h4 class="pl-3">New Week ID: {{ returned_data.unit_id }}</h4>
                    <h4 class="pl-3">New Week Title: {{ returned_data.unit_title }}</h4>  
                    <div v-if="returned_data.articles.length > 0">
                    <h5 class="pl-3 pt-3">Articles</h5>
                    <div v-for="(ret_article, index) in returned_data.articles" v-if="ret_article.article_title" class="pl-3">
                        <div class="h6 mb-3 mt-3 d-flex btn btn-primary">
                            <span
                                class="collapse-icon mr-2 d-flex justify-content-center align-items-center"
                                :class="{'collapsed': !collapsed_articles[index]}"
                                :aria-expanded="collapsed_articles[index] ? 'true' : 'false'"
                                @click="toggleArticle(index)"
                            >
                                <span class="open">
                                    <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                                </span>
                                <span class="closed">
                                    <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                                </span>
                            </span>
                            <span
                                class="mr-1 cursor-pointer"
                                @click="toggleArticle(index)"
                            >
                                {{ret_article.article_title}}
                            </span>
                        </div>
                        <b-collapse
                            :visible="collapsed_articles[index]"
                            @input="val => $set(collapsed_articles, index, val)"
                            :class="collapsed_articles[index] ? null : 'collapsed'"
                        >
                            <div class="card p-3 mt-3" style="background-color: lightblue;">
                                <div>Article Title: {{ ret_article.article_title }}</div>
                                <div>Article Body: 
                                    <TipTap
                                        ref="article-body"
                                        v-model="ret_article.full_article.body"
                                        :menu_items="[]"
                                        :min_height="true"
                                        :readonly="true"
                                    />
                                </div>
                                <div v-if="ret_article.full_article.citations" class="mt-3">
                                    Article Citations Added:
                                    <TipTap
                                        v-model="ret_article.full_article.citations"
                                        :menu_items="[]"
                                        :min_height="true"
                                        :readonly="true"
                                    />
                                </div>
                                Article Vocabulary Added: 
                                <div class="card p-3 mb-3 mt-3">
                                    <div v-for="vocab in ret_article.vocabulary">
                                        <b>{{ vocab.term }}:</b> {{ vocab.definition }}
                                    </div>
                                </div>
                                Article Questions Added:
                                <div class="card p-3 mt-3">
                                    <div v-for="question in ret_article.article_questions">
                                        <Question
                                            class="mb-2"
                                            :question="question"
                                            :publication="{}"
                                            :unit="{}"
                                            :disabled="true"
                                            :hide_standards="true"
                                        />
                                    </div>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
                
            </div>

            <template #modal-footer>
                <div v-if="!uploading_blueprint">
                    <b-button
                        variant="primary"
                        @click="uploadBlueprint"
                        :disabled="uploadDisabled()"
                    >
                        Upload Blueprint
                    </b-button>
                </div>
                <div v-else>
                    <b-spinner small label="Uploading..."></b-spinner>
                    Uploading File - This may take a minute
                </div>
                <b-button
                    variant="warning"
                    @click="clearForm()"
                >
                    Clear Form
                </b-button>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Close
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import TipTap from '@/components/tiptap/TipTap'
import Question from '@/components/article/Question.vue';
export default {
    data: () => ({
        submit_data: {
            file: null,
        },
        uploading_blueprint: false,
        returned_data: null,
        collapsed_articles: [],
    }),
    props: [
        'value', 
        'unit_group', 
    ],
    components: {
        TipTap,
        Question,
    },
    watch: {
        // Initialize (and re-initialize) when articles change
        'returned_data.articles': {
            handler(articles) {
                if (Array.isArray(articles)) {
                    this.collapsed_articles = articles.map(() => false);
                } else {
                    this.collapsed_articles = [];
                }
            },
            immediate: true
        }
    },
    methods: {
        uploadDisabled(){
            return this.submit_data.file == null || this.uploading_blueprint || this.returned_data != null;
        },
        toggleArticle(index) {
            this.$set(this.collapsed_articles, index, !this.collapsed_articles[index]);
        },
        async uploadBlueprint(event){
            if (this.uploadDisabled()) {
                return;
            }

            let file = null;
            let form_data = new FormData();
            file = this.submit_data.file;
            form_data.append('file', file);
            this.uploading_blueprint = true;

            try{
                const response = await this.axios.post('/api/unit_groups/create_unit_from_blueprint/' + this.unit_group.id, form_data)
                this.uploading_blueprint = false;
                if(!response){
                    this.$bvToast.toast('An error has ocurred', {
                        title: 'Error',
                        variant: 'danger',
                        solid: false,
                        autoHideDelay: 3000,
                        appendToast: true
                    })
                }
                else{
                    this.$bvToast.toast('Blueprint was successfully uploaded', {
                        title: 'Success',
                        variant: 'success',
                        solid: false,
                        autoHideDelay: 3000,
                        appendToast: true
                    })
                    this.returned_data = response.data;
                }
                this.$emit('getUnits');
            } catch (e) {
                this.uploading_blueprint = false;
            } finally {
                this.uploading_blueprint = false;
            }
        },
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide () {
            this.clearForm();
            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')
        },
        clearForm(){
            this.submit_data = {
                file: null,
            };
            this.uploading_blueprint = false;
            this.returned_data = null;
            this.collapsed_articles = [];
        },
    }
}
</script>
